module.exports = __webpack_public_path__ + "static/media/history_2.8b383940.jpg";